import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, Table, Row, Col,
} from 'antd';
import { useQuery } from 'react-query';
import moment from 'moment';

import Deployment from './deployments/Deployment';
import PlatformEvent from './PlatformEvent';
import { getPlatformEvents } from '../../../services/dataset.service';

const DeploymentsTab = (props) => {
  const { obsDatasetSummary } = props;

  const platformId = obsDatasetSummary?.obs_dataset_platform_assignment?.platform?.platform_id;

  const {
    data: platformEvents,
  } = useQuery(
    ['platformEvents', platformId],
    // TODO: centralize query keys
    () => getPlatformEvents(platformId),
    {
      refetchOnWindowFocus: false,
      enabled: !!platformId,
    },
  );

  const tableData = platformEvents?.map((event) => ({
    ...event,
    key: event.platform_event_id,
  }));

  const columns = [
    {
      title: 'Action',
      dataIndex: 'event',
      key: 'event',
    },
    {
      title: 'Date',
      dataIndex: 'event_time',
      key: 'event_time',
      render: (date) => moment(date).format('MM/DD/YYYY h:mma'),
    },
    {
      title: 'Details',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  return (
    <Row
      gutter={16}
    >
      <Col
        xs={24}
        lg={8}
      >
        <Card
        // variant="borderless"
          bordered={false}
          title={(
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              Deployment
              <PlatformEvent platformEvent={obsDatasetSummary?.obs_dataset_platform_assignment?.platform?.platform_event?.event} />
            </div>
          )}
          style={{
            backgroundColor: '#03304b', // TODO: replace with brand var
            border: '1px solid #4f6f81',
            alignSelf: 'start',
          }}
        >
          <Deployment obsDatasetSummary={obsDatasetSummary} />
        </Card>
      </Col>
      <Col
        xs={24}
        lg={16}
      >
        <Table
          className="platform-dashboard-table"
          columns={columns}
          dataSource={tableData}
          pagination={{ pageSize: 6 }}
        />
      </Col>
    </Row>
  );
};

DeploymentsTab.propTypes = {
  obsDatasetSummary: PropTypes.object,
};

DeploymentsTab.defaultProps = {
  obsDatasetSummary: {},
};

export default DeploymentsTab;
